import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { requestBU as request } from 'api/common';
import useBUsState from 'global/buState';

/**
 * BU 목록
 */
function useBUState() {
  /* router */
  const { pathname } = useLocation();

  /* recoil */
  const { setBU } = useBUsState();

  /* watch */
  useLayoutEffect(() => {
    requestBU();
  }, [pathname]);

  /* method */
  // BU 목록 조회 요청
  const requestBU = async () => {
    const { list = [] } = await request();

    setBU(list);
  };
}

export default useBUState;
